import { Column } from '@ant-design/plots';
import utils from '../Common/utils';

const getColumnWidthRatio = (len) => {
  if (len < 2) return 0.1;
  if (len < 3) return 0.25;
  if (len < 5) return 0.5;
  if (len < 10) return 0.6;
  if (len < 15) return 0.7;
  return 0.8;
};

// Single-series chart for the DDV insights page: only the net difference
// (total_tax) per period. Green when it nets to a refund (>0), red when payable.
const TaxNetChart = ({ data = [] }) => {
  const chartData = data.map(x => ({
    dt_str: x.dt_str,
    value: Number(x.total_tax) || 0,
  }));

  const config = {
    data: chartData,
    xField: 'dt_str',
    yField: 'value',
    columnWidthRatio: getColumnWidthRatio(data.length),
    color: (datum) => (datum.value >= 0 ? 'green' : 'red'),
    label: {
      position: 'middle',
      content: (datum) => utils.formatToThousands(datum.value),
      style: { fill: 'white', fontSize: 12 },
    },
    yAxis: {
      title: { text: 'Δ Neto razlika (€)', style: { fill: 'grey', fontSize: 12 } },
      nice: true,
      label: { formatter: (val) => utils.formatToThousands(val) },
    },
    xAxis: {
      label: { autoHide: true, autoRotate: true },
    },
    tooltip: {
      formatter: (datum) => ({
        name: 'Δ Neto razlika',
        value: utils.formatToMoney(datum.value),
      }),
    },
    padding: 'auto',
  };

  return <Column {...config} />;
};

export default TaxNetChart;
